import { render, staticRenderFns } from "./FaceOrFaces.vue?vue&type=template&id=138a7ce2&scoped=true&"
import script from "./FaceOrFaces.vue?vue&type=script&lang=js&"
export * from "./FaceOrFaces.vue?vue&type=script&lang=js&"
import style0 from "./FaceOrFaces.vue?vue&type=style&index=0&id=138a7ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a7ce2",
  null
  
)

export default component.exports